import styles from "./styles.js";
import React from "react";
import { View, Text, TextInput, Platform } from "react-native";
import textConstants from "../../constants/textConstants.js";
import CommonButton from "../../commonComponents/Button.js";
import InternetBanking from "../../screens/paymentScreen/internetBankingOption";

//show debit/credit card input fields
export const createCreateDebitCardInputs = (
  elements_profile,
  textInputChange
) => {
  for (var i = 0; i < elements_profile.length; i++) {
    if (elements_profile[i].name === textConstants.debitCreditCard) {
      return elements_profile[i].childrenArr.map(
        (itm, idx) =>
          itm.type === "text" && (
            <View
              key={idx}
              nativeID={`textField_${idx}`}
              style={[
                styles.paymentTextInputChildView,
                styles.expandableView,
                styles.paddingDebitCard,
              ]}
            >
              <TextInput
                keyboardType={itm.keyboardType}
                placeholder={itm.placeholder}
                value={itm.value}
                onChangeText={(e) => {
                  textInputChange(itm.name, e, idx, elements_profile[i].name);
                }}
                style={
                  Platform.OS == "web"
                    ? [styles.paymentTextInput, { outline: "none" }]
                    : [styles.paymentTextInput]
                }
                secureTextEntry={itm.name === textConstants.CVV ? true : false}
                maxLength={itm.maxLength}
              />
              {itm.correct ? (
                <Text />
              ) : (
                <Text style={styles.errorMsgtxt}>{itm.errorMsg}</Text>
              )}
            </View>
          )
      );
    }
  }
};

//show Radio button & bank name for Internet Banking
export const createInternetBankingInputs = (
  elements_profile,
  selectedBank,
  onPressButton
) => {
  for (var i = 0; i < elements_profile.length; i++) {
    if (elements_profile[i].name === textConstants.internetBanking) {
      return (
        <View
          style={[
            styles.paymentInputRadioButtonViewBox,
            styles.expandableView,
            //styles.paddingLeft30,
            styles.internetBanking,
          ]}
        >
          <InternetBanking
            inputArray={elements_profile[i].childrenArr}
            selectedBank={selectedBank}
            onPressButton={onPressButton}
            elements_profile={elements_profile}
          />

          {/* {itm.correct ? (
                <Text />
              ) : (
                <Text style={styles.errorMsgtxt}>{itm.errorMsg}</Text>
              )} */}
        </View>
      );
    }
  }
};

const onClickButton = (name, elements_profile, onPressButton) => {
  let data = onPayBtnClick(name, elements_profile);
  onPressButton(data);
};

//rendering pay now button
export const renderPaynowBtn = (name, elements_profile, onPressButton) => {
  return (
    <CommonButton
      onPress={() => onClickButton(name, elements_profile, onPressButton)}
      ButtonText={"Submit"}
    />
  );
};

//on Pay button click, validates input fields and directs to Payment page
export const onPayBtnClick = (name, elements_profile) => {
  let data;
  var config = elements_profile;
  var error = true;
  let cardNumberError = true;
  let cardNameError = true;
  let expiryError = true;
  let cvvError = true;

  let customerCare = true;
  let bankName = true;
  let accountName = true;
  let sortCode = true;
  if (name === textConstants.debitCreditCard) {
    for (var i = 0; i < elements_profile.length; i++) {
      for (var j = 0; j < elements_profile[i].childrenArr.length; j++)
        if (config[i].childrenArr[j].name === textConstants.cardNumber) {
          if (
            config[i].childrenArr[j].value.length === 19 &&
            config[i].childrenArr[j].value !== "" &&
            config[i].childrenArr[j].correct === true
          ) {
            cardNumberError = false;
            error = false;
            config[i].childrenArr[j].correct = true;
            config[i].childrenArr[j].errorMsg = "";
          } else {
            cardNumberError = true;

            error = true;
            config[i].childrenArr[j].correct = false;
            config[i].childrenArr[j].errorMsg =
              textConstants.cardNumberErrorMsg;
          }
        } else if (config[i].childrenArr[j].name === textConstants.nameOnCard) {
          if (
            config[i].childrenArr[j].value !== "" &&
            config[i].childrenArr[j].correct === true
          ) {
            cardNameError = false;
            error = false;
            config[i].childrenArr[j].correct = true;
          } else {
            cardNameError = true;

            error = true;
            config[i].childrenArr[j].correct = false;
            config[i].childrenArr[j].errorMsg =
              textConstants.nameOnCardErrorMsg;
          }
        } else if (config[i].childrenArr[j].name === textConstants.expiry) {
          if (
            config[i].childrenArr[j].value !== "" &&
            config[i].childrenArr[j].value.length === 5 &&
            config[i].childrenArr[j].correct === true
          ) {
            expiryError = false;
            error = false;
            config[i].childrenArr[j].correct = true;
          } else {
            expiryError = true;
            error = true;
            config[i].childrenArr[j].correct = false;
            config[i].childrenArr[j].errorMsg = textConstants.expiryErrorMsg;
          }
        } else if (config[i].childrenArr[j].name === textConstants.CVV) {
          if (
            config[i].childrenArr[j].value !== "" &&
            config[i].childrenArr[j].value.length === 3 &&
            config[i].childrenArr[j].correct === true
          ) {
            cvvError = false;
            error = false;
            config[i].childrenArr[j].correct = true;
          } else {
            cvvError = true;
            error = true;
            config[i].childrenArr[j].correct = false;
            config[i].errorMsg = textConstants.cvvErrorMsg;
          }
        }
    }

    if (
      !error &&
      cardNumberError == false &&
      cardNameError == false &&
      expiryError == false &&
      cvvError == false
    ) {
      data = {
        configData: config,
        debitCard: true,
        valid: true,
        internetBanking: false,
      };
      return data;
    } else {
      data = {
        configData: config,
        debitCard: true,
        valid: false,
        internetBanking: false,
      };
      return data;
    }
  } else if (name === textConstants.internetBanking) {
    for (var i = 0; i < elements_profile.length; i++) {
      if (config[i].name === "Customer Name") {
        if (config[i].value !== "" && config[i].correct === true) {
          customerCare = false;
          error = false;
          config[i].correct = true;
        } else {
          customerCare = true;

          error = true;
          config[i].correct = false;
        }
      } else if (config[i].name === "Bank Name") {
        if (config[i].value !== "" && config[i].correct === true) {
          bankName = false;
          error = false;
          config[i].correct = true;
        } else {
          bankName = true;

          error = true;
          config[i].correct = false;
        }
      } else if (config[i].name === "Account Number") {
        if (
          config[i].value !== "" &&
          config[i].value.length > 9 &&
          config[i].correct === true
        ) {
          accountName = false;
          error = false;
          config[i].correct = true;
        } else {
          accountName = true;
          error = true;
          config[i].correct = false;
        }
      } else if (config[i].name === "Sort Code") {
        if (
          config[i].value !== "" &&
          config[i].value.length === 8 &&
          config[i].correct === true
        ) {
          sortCode = false;
          error = false;
          config[i].correct = true;
        } else {
          sortCode = true;
          error = true;
          config[i].correct = false;
        }
      }

      if (
        !error &&
        customerCare == false &&
        bankName == false &&
        accountName == false &&
        sortCode == false
      ) {
        apis.payment
          .doPayment({
            customerId: this.state.customerId,
            accountNumber: config[2].value,
          })
          .then(() => {
            if (Platform.OS === "web") {
              this.props.history.push(SUCCESS_PAYMENT);
            } else {
              this.props.navigation.navigate(SUCCESS_PAYMENT, {
                // props to pass here
              });
            }
          })
          .catch((error) => {
            if (Platform.OS === "web") {
              this.props.history.push(FAILED_PAYMENT);
            } else {
              this.props.navigation.navigate(FAILED_PAYMENT, {
                // props to pass here
              });
            }
          });
      } else if (i === elements_profile.length - 1) {
        this.setState({
          disableSubmit: false,
        });
      }
    }

    for (var i = 0; i < elements_profile.length; i++) {
      for (var j = 0; j < elements_profile[i].childrenArr.length; j++) {
        if (config[i].childrenArr[j].name === textConstants.internetBanking) {
          if (
            config[i].childrenArr[j].value !== "" &&
            config[i].childrenArr[j].correct === true
          ) {
            error = false;
            config[i].childrenArr[j].correct = true;
            config[i].childrenArr[j].errorMsg = "";
          } else {
            error = true;
            config[i].childrenArr[j].correct = false;
            config[i].childrenArr[j].errorMsg =
              config[i].childrenArr[j].errorMsg;
          }
        }
      }
    }

    if (!error) {
      data = {
        configData: config,
        debitCard: false,
        valid: true,
        internetBanking: true,
      };
      return data;
    } else {
      data = {
        configData: config,

        debitCard: false,
        valid: false,
        internetBanking: true,
      };
      return data;
    }
  } else {
  }
};
